"use client";
import { IBlocks } from "@/types";
import { Input } from "@/components/ui/input";
import React from "react";
import { startsWithHTTPS } from "@/lib/utils";
import { toast } from "sonner";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function TwitterFeedOptions({
    block,
    blockUpdate,
    update,
}: Props) {
    const [url, setUrl] = React.useState(block.url);
    const [oldBlock, setOldBlock] = React.useState(block);
    return (
        <CardSetting noBorder>
            <div className="flex w-full flex-col gap-3">
                <Input
                    label="Twitter/X Username"
                    variant="card"
                    className="w-full"
                    type="text"
                    value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                        blockUpdate({
                            ...block,
                            url: e.target.value,
                        });
                    }}
                    onBlur={(e) => {
                        if (oldBlock.url != e.target.value) {
                            update({
                                ...block,
                                url: e.target.value,
                            });
                            setOldBlock({
                                ...oldBlock,
                                url: e.target.value,
                            });
                        }
                    }}
                />
            </div>
        </CardSetting>
    );
}
